/** Resolve the persisted object name by DI id; never guess from its visible number. */
export async function resolveDiPdfFilename(endpoint, token, id) {
  if (!id || Number(id) <= 0) throw new Error('DI id is required');
  const response = await fetch(`${endpoint}/form/getpdffilename/${encodeURIComponent(id)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('DI PDF identity could not be resolved');
  const data = await response.json();
  if (!data.filename || typeof data.filename !== 'string') throw new Error('DI PDF filename is missing');
  return data.filename;
}
